import API, { config } from './_main';
import * as FleetModule from 'Modules/FleetModule';
import { AxiosPromise } from 'axios';

export function updateFleet(fleetId: number, fleetData: FleetModule.Types.AddFleetRequest): AxiosPromise<FleetModule.Types.UserFleetResponse> {
    return API.put(`fleet/${fleetId}`, fleetData, config());
}

export function deleteFleet(fleetId: number) {
    return API.delete(`fleet/${fleetId}`, config());
}

export function deleteCarFromFleet(fleetId: number, carId: number) {
    return API.delete(`fleet/${fleetId}/car/${carId}`, config());
}

export function getUserFleets(params?: URLSearchParams): AxiosPromise<FleetModule.Types.UserFleetsResponse> {
    return API.get(`fleet`, config(params));
}
export function getFleetById(fleetId: number): AxiosPromise<FleetModule.Types.UserFleetResponse> {
    return API.get(`fleet/${fleetId}`, config());
}
export function addNewFleet(fleetData: FleetModule.Types.AddFleetRequest): AxiosPromise<FleetModule.Types.UserFleetResponse> {
    return API.post('fleet', fleetData, config());
}



// WEBPACK FOOTER //
// ./src/Connectors/FleetConnector.ts